import Core from './core';

async function userHasPermission(adminId: number, name: string) {
  try {
    const api = Core.getInstance().api();
    return api.get(
      `/user/permission?adminId=${adminId}&permissionName=${name}`,
    );
  } catch (error: any) {
    return error;
  }
}

export const permissionService = {
  userHasPermission,
};
